<template>
  <div class="message">
    <h3>{{ $t('navbar.message') }}</h3>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('navbar.message')" name="first">
        <div class="content">
          <el-table
            :data="tableData"
            :header-cell-style="{
              background: '#FDC400',
              color: '#333333',
              borderradius: '4px 4px 0px 0px',
              height: '42px',
            }"
          >
            <el-table-column prop="name" :label="$t('minMessage.addresser')" width="75">
              <template slot-scope="scope">
                <div class="company">
                  <span>{{ scope.row.name }}</span>
                  <span v-if="scope.row.count" class="count">{{ scope.row.count }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="companyNameC" :label="$t('minMessage.company')"> </el-table-column>
            <el-table-column prop="duty" :label="$t('minMessage.department')">
              <template slot-scope="scope">
                <span>{{ scope.row.duty || scope.row.dept }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="time" :label="$t('minMessage.sendTime')">
            </el-table-column> -->
            <el-table-column :label="$t('common.operate')" width="65">
              <template slot-scope="scope">
                <el-button type="text" class="view" @click="view(scope.row)"> {{ $t('minMessage.look') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('common.received')">
        <CardList></CardList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getMyMessageLists } from '../../../../../api/message.js';
import MobileHead from '../../../comment/mobile/mobileHead.vue';
import CardList from './components/cardList.vue';
export default {
  data() {
    return {
      activeName: 'first',
      value: '',
      currentPage4: 1,
      tableData: [],
    };
  },
  components: {
    CardList,
    MobileHead,
  },
  created() {
    this.getList();
  },
  methods: {
    view(row) {
      this.$router.push({
        name: 'messageDetail',
        query: {
          sendUserId: row.sendUserId,
          receiveUserId: row.receiveUserId,
        },
      });
      localStorage.setItem('name', row.name);
      localStorage.setItem('companyName', row.companyNameC);
      const counts = this.$store.state.count - row.count;
      this.$store.commit('updataCount', counts);
    },
    getAllCount(lists) {
      var counts = 0;
      if (lists.length >= 1) {
        lists.map((item) => {
          counts += item.count;
        });
      }
      this.$store.commit('updataCount', counts);
    },
    async getList() {
      try {
        const { data } = await getMyMessageLists();
        if (data.code === 200) {
          this.tableData = data.data;
          this.getAllCount(data.data);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.message {
  box-sizing: border-box;
  padding: 2.6vw;
  background: #f0f2f5;
  min-height: 800px;
  h3 {
    font-size: 5.3vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
    background: white;
    // margin-top: 16vw;
    box-sizing: border-box;
    padding: 4vw 0 4vw 1vw;
  }
  .content {
    // padding: 25px 30px 40px 0px;
    box-sizing: border-box;
    text-align: center;
    .company {
      display: flex;
      .count {
        width: 24px;
        height: 20px;
        background: #ff190c;
        border-radius: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 10px;
        text-align: center;
      }
    }
    .view {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #006fb8;
      line-height: 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style scoped>
.el-table >>> td,
.el-table >>> th {
  padding: 8px 0;
}
.message >>> .el-tabs {
  /* background: white; */
  padding-left: 4vm;
}
.message >>> .el-tabs__header {
  background: #fff;
}
.message >>> .el-tabs__nav-wrap {
  padding-left: 2vw;
}
</style>
